import { Action } from 'redux';

export enum DialogActionTypes {
    SHOW = '@@dialog/SHOW',
    UPDATE = '@@dialog/UPDATE',
    HIDE = '@@dialog/HIDE',
    DISABLE = '@@dialog/DISABLE',
}
export interface ShowDialogAction extends Action {
    type: DialogActionTypes.SHOW;
    payload: {
        isOpened: boolean;
        body: JSX.Element | JSX.Element[] | string;
        customButtons?: JSX.Element | JSX.Element[] | string;
        title: string;
        onClickCancel?(): void;
        onClickConfirm?(): void;
        onClickDestructive?(): void;
        cancelLabel?: string;
        confirmLabel?: string;
        destructiveLabel?: string;
        fullScreen?: boolean;
        isDisabled?: any;
        ref?: any;
        width?: string | number;
        height?: string | number;
        id?: string | number;
        isHiddenManually?: boolean;
        disableHeader?: boolean;
        disableFooter?: boolean;
        disabledContentPadding?: boolean;
        header?: JSX.Element;
        onClose?: () => void;
    };
}

export interface UpdateDialogAction extends Action {
    type: DialogActionTypes.UPDATE;
    payload: {
        isOpened?: boolean;
        body?: JSX.Element | JSX.Element[] | string;
        title?: string;
        onClickCancel?(): void;
        onClickConfirm?(): void;
        onClickDestructive?(): void;
        cancelLabel?: string;
        confirmLabel?: string;
        destructiveLabel?: string;
        fullScreen?: boolean;
        isDisabled?: any;
        width?: string | number;
        height?: string | number;
        isLoading?: boolean;
        disableFooter?: boolean;
        onClose?: () => void;
    };
}

export interface HideDialogAction extends Action {
    type: DialogActionTypes.HIDE;
    payload: {
        isOpened: boolean;
    };
}

export interface DisableDialogAction extends Action {
    type: DialogActionTypes.DISABLE;
    payload: {
        isDisabled: boolean;
    };
}

export interface DialogState {
    isOpened: boolean;
    title?: string;
    body?: JSX.Element | JSX.Element[] | string;
    onClickCancel?(): void;
    onClickConfirm?(): void;
    cancelLabel?: string;
    confirmLabel?: string;
    isDisabled?: any;
    width?: string;
    height?: string;
    id?: string | number;
    disableFooter?: boolean;
    onClose?: () => void;
}

export type ShowDialogParams = {
    body?: JSX.Element | JSX.Element[] | string;
    customButtons?: JSX.Element | JSX.Element[] | string;
    onClickCancel?(): void;
    onClickConfirm?(): void;
    onClickDestructive?(): void;
    cancelLabel?: string;
    confirmLabel?: string;
    destructiveLabel?: string;
    title?: string;
    fullScreen?: boolean;
    isDisabled?: any;
    width?: string | number;
    height?: string | number;
    id?: string | number;
    isHiddenManually?: boolean;
    isLoading?: boolean;
    disableHeader?: boolean;
    disableFooter?: boolean;
    disabledContentPadding?: boolean;
    header?: JSX.Element;
    onClose?: () => void;
};
